var _module = require('../../components/module');

require('angular-ui-bootstrap/src/modal');
require('../lr-touch');
require('../user');
require('../fullscreen-loading');
require('../analytics');
require('../activity-feed');
require('../../components/login');

_module.requires.push('ui.bootstrap.module.modal');

_module.service('$affiliateModal', [
    '$log',
    '$uibModal',
    '$user',
    '$fsloading',
    '$analytics',
    '$activityFeed',

    function $affiliateModalService($log, $uibModal, $user, $fsloading, $analytics, $activityFeed) {
        return function openAffiliateModal() {
            var modal = $uibModal.open({
                template: require('./index.html'),
                controller: [
                    '$scope',

                    function affiliateModalCtrl($scope) {
                        $scope.show404Error = false;

                        // Functions
                        $scope.setAffiliate = function setAffiliate() {
                            $log.debug('$scope.affiliateLinkForm', $scope.affiliateLinkForm.$valid, $scope.affiliateLinkForm);

                            $scope.show404Error = false;

                            if($scope.affiliateLinkForm.$valid) {
                                $fsloading.show();

                                $user.setAffiliateId($scope.affiliateLinkForm.data.affiliateLink.split('/').pop().toLowerCase())
                                    .then(function setAffiliateResponse() {
                                        $analytics.eventTrack('Affiliate Code Submit');
                                        $scope.$close();
                                    })
                                    .catch(function setAffiliateError(err) {
                                        $scope.show404Error = true;
                                    })
                                    .finally(function setAffiliateFinally() {
                                        $fsloading.hide();
                                    });
                            }
                        };

                        $scope.activationExpired = function activationExpired() {
                            openAffiliateModal();
                        };
                    }
                ],
                backdrop: 'static',
                windowClass: 'affiliate-modal',
                keyboard: false
            });

            return modal;
        };
    }
]);
